import cx from 'classnames';
import type { FunctionComponent } from 'react';

import styles from './BoldText.module.less';

type Props = {
  weight?: 'light' | 'normal' | 'medium' | 'semibold' | 'bold' | 'extrabold' | 'black';
};

/**
 * Simple helper generic to bold text with the FOSSA weight levels.
 *
 * _Why do we need this?_
 *
 * Using CSS instead of `<b>` provides bettert control over the content.
 */
const BoldText: FunctionComponent<Props> = ({ children, weight = 'medium' }) => {
  return (
    <span
      className={cx(styles.boldText, {
        [styles.light]: weight === 'light',
        [styles.normal]: weight === 'normal',
        [styles.medium]: weight === 'medium',
        [styles.semibold]: weight === 'semibold',
        [styles.bold]: weight === 'bold',
        [styles.extrabold]: weight === 'extrabold',
        [styles.black]: weight === 'black',
      })}
    >
      {children}
    </span>
  );
};

export default BoldText;
